import { render, staticRenderFns } from "./HealthOrg.vue?vue&type=template&id=5e0377e7&"
import script from "./HealthOrg.vue?vue&type=script&lang=js&"
export * from "./HealthOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports